import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

    constructor(
      private http: HttpClient
    ) { }
    
    getUrlIdentity() {
      return 'apiRoferV2/rofer_identity';
    }

    getUrlEpicor() {
      return 'apiRoferV2/epicor_rofer';
    }
    
    getUrlRofer(){
      return 'apiRoferV2/rofer';
    }

    getUrlContador(){
      return 'contador';
    }

    getUrlCompanyConfig(){
      return 'CompanyConfig';
    }

    Get(apiURL){
      const promise = new Promise(async (resolve, reject) => {
        this.http
          .get<any[]>(apiURL)
          .toPromise()
          .then((res: any) => {
            // Success
            resolve(res);
          },
            err => {
              // Error
              reject(err);
            }
          );
      });
      return promise;
    }

    Post(apiURL, item){
      
      const promise = new Promise(async (resolve, reject) => {
        this.http
          .post<any[]>(apiURL, item)
          .toPromise()
          .then((res: any) => {
            // Success
            resolve(res);
          },
            err => {
              // Error
              reject(err);
            }
          );
      });
      return promise;
    }

    Put(apiURL, item){
      
      const promise = new Promise(async (resolve, reject) => {
        this.http
          .put<any[]>(apiURL, item)
          .toPromise()
          .then((res: any) => {
            // Success
            resolve(res);
          },
            err => {
              // Error
              reject(err);
            }
          );
      });
      return promise;
    }
    
    Delete(apiURL){
      
      const promise = new Promise(async (resolve, reject) => {
        this.http
          .delete<any[]>(apiURL)
          .toPromise()
          .then((res: any) => {
            // Success
            resolve(res);
          },
            err => {
              // Error
              reject(err);
            }
          );
      });
      return promise;
    }
}